import { createRouter, createWebHistory } from 'vue-router';

import DefaultLayout from "./components/Layouts/DefaultLayout/DefaultLayout";
import Index from "./pages/Index/Index";
import About from "./pages/About/About";
import FullList from "./pages/FullList/FullList";
import PlanYourVisit from "./pages/PlanYourVisit/PlanYourVisit";
import Movies from "./pages/Movies/Movies";
import VRMovies from "./pages/VRMovies/VRMovies";
import HelpfulInfo from "./pages/HelpfulInfo/HelpfulInfo";
import Popular from "./pages/Popular/Popular";
import Other from "./pages/Other/Other";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Copyright from "./pages/Copyright/Copyright";
import TermsOfUse from "./pages/TermsOfUse/TermsOfUse";
import Contact from "./pages/Contact/Contact";
import SeasonalEventsAndExperience from "./pages/SeasonalEventsAndExperience/SeasonalEventsAndExperience";
import Articles from "./pages/Articles/Articles";
import LuxuryTravel from "./pages/LuxuryTravel/LuxuryTravel";
import LuxuryTravel01 from "./pages/LuxuryTravel/LuxuryTravel01/LuxuryTravel01";
import LuxuryTravel02 from "./pages/LuxuryTravel/LuxuryTravel02/LuxuryTravel02";
import LuxuryTravel03 from "./pages/LuxuryTravel/LuxuryTravel03/LuxuryTravel03";
import LuxuryTravel04 from "./pages/LuxuryTravel/LuxuryTravel04/LuxuryTravel04";
import LuxuryTravel05 from "./pages/LuxuryTravel/LuxuryTravel05/LuxuryTravel05";
import LuxuryTravel06 from "./pages/LuxuryTravel/LuxuryTravel06/LuxuryTravel06";
import SpiritOfJapan from "./pages/SpiritOfJapan/SpiritOfJapan";
import DiscoverMore from "./pages/DiscoverMore/DiscoverMore";
import SpiritOfJapan2 from "@/pages/SpiritOfJapan2/SpiritOfJapan2.vue";
import DiscoverMore2 from "@/pages/DiscoverMore2/DiscoverMore2.vue";
import SpiritOfJapan3 from "@/pages/SpiritOfJapan3/SpiritOfJapan3.vue";
import SpiritOfJapan4 from "./pages/SpiritOfJapan4/SpiritOfJapan4.vue";
import SpiritOfJapan5 from "./pages/SpiritOfJapan5/SpiritOfJapan5.vue";
import SpiritOfJapan6 from "./pages/SpiritOfJapan6/SpiritOfJapan6.vue";
import SpiritOfJapan7 from "./pages/SpiritOfJapan7/SpiritOfJapan7.vue";
// 反映時は削除↓
import Kiji from "./pages/Popular/Detail/template";
// 反映時は削除↑

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_PATH),
    routes:[
        {
            path: '/',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Index',
                    component: Index,
                },
                {
                    path: 'about/',
                    name: 'About',
                    component: About,
                },
                {
                    path: 'full_list/',
                    name: 'FullList',
                    component: FullList,
                },
                {
                    path: 'plan_your_visit/',
                    name: 'PlanYourVisit',
                    component: PlanYourVisit,
                },
                {
                    path: 'movies/',
                    name: 'Movies',
                    component: Movies,
                },
                {
                    path: 'vr_movies/',
                    name: 'VRMovies',
                    component: VRMovies,
                },
                {
                    path: 'helpful_info/',
                    name: 'HelpfulInfo',
                    component: HelpfulInfo,
                },
                {
                    path: 'popular/:url',
                    name: 'Popular',
                    component: Popular,
                    props: true,
                },
                {
                    path: 'other/',
                    name: 'Other',
                    component: Other,
                },
                {
                    path: 'privacy/',
                    name: 'PrivacyPolicy',
                    component: PrivacyPolicy,
                },
                {
                    path: 'copyright/',
                    name: 'Copyright',
                    component: Copyright,
                },
                {
                    path: 'terms_of_use/',
                    name: 'TermsOfUse',
                    component: TermsOfUse,
                },
                {
                    path: 'contact/',
                    name: 'Contact',
                    component: Contact,
                },
                {
                    path: 'seasonal_events_and_experience/',
                    name: 'SeasonalEventsAndExperience',
                    component: SeasonalEventsAndExperience,
                },
                {
                    path: 'articles/',
                    name: 'Articles',
                    component: Articles,
                },
                {
                    path: '/luxurytravel',
                    name: 'LuxuryTravel',
                    component: LuxuryTravel,
                },
                {
                    path: '/luxurytravel01',
                    name: 'LuxuryTravel01',
                    component: LuxuryTravel01,
                },
                {
                    path: '/luxurytravel02',
                    name: 'LuxuryTravel02',
                    component: LuxuryTravel02,
                },
                {
                    path: '/luxurytravel03',
                    name: 'LuxuryTravel03',
                    component: LuxuryTravel03,
                },
                {
                    path: '/luxurytravel04',
                    name: 'LuxuryTravel04',
                    component: LuxuryTravel04,
                },
                {
                    path: '/luxurytravel05',
                    name: 'LuxuryTravel05',
                    component: LuxuryTravel05,
                },
                {
                    path: '/luxurytravel06',
                    name: 'LuxuryTravel06',
                    component: LuxuryTravel06,
                },
                {
                    path: '/spirit_of_japan/1',
                    name: 'SpiritOfJapan1',
                    component: SpiritOfJapan,
                },
                {
                    path: '/spirit_of_japan/2',
                    name: 'SpiritOfJapan2',
                    component: SpiritOfJapan2,
                },
                {
                    path: '/spirit_of_japan/3',
                    name: 'SpiritOfJapan3',
                    component: SpiritOfJapan3,
                },
                {
                    path: '/spirit_of_japan/4',
                    name: 'SpiritOfJapan4',
                    component: SpiritOfJapan4,
                },
                {
                    path: '/spirit_of_japan/5',
                    name: 'SpiritOfJapan5',
                    component: SpiritOfJapan5,
                },
                {
                    path: '/spirit_of_japan/6',
                    name: 'SpiritOfJapan6',
                    component: SpiritOfJapan6,
                },
                {
                    path: '/spirit_of_japan/7',
                    name: 'SpiritOfJapan7',
                    component: SpiritOfJapan7,
                },
                {
                    path: '/discover_more/1',
                    name: 'DiscoverMore1',
                    component: DiscoverMore,
                },
                {
                    path: '/discover_more/2',
                    name: 'DiscoverMore2',
                    component: DiscoverMore2,
                },
                // 反映時は削除↓
                {
                    path: 'kiji/',
                    name: 'Kiji',
                    component: Kiji,
                },
                // 反映時は削除↑
            ],
        }
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

export default router;
